import { TILE_W, TILE_H } from './config';

// Tile <-> screen conversion for the classic 2:1 isometric "diamond" grid.
// Tile (0,0) sits at screen origin; tile (1,0) is half-tile right & down.

export function tileToScreen(tx: number, ty: number): { sx: number; sy: number } {
  return {
    sx: (tx - ty) * (TILE_W / 2),
    sy: (tx + ty) * (TILE_H / 2),
  };
}

export function screenToTile(sx: number, sy: number): { tx: number; ty: number } {
  const tx = sx / (TILE_W / 2) + sy / (TILE_H / 2);
  const ty = sy / (TILE_H / 2) - sx / (TILE_W / 2);
  return { tx: tx / 2, ty: ty / 2 };
}

// Render-order depth so southward / eastward tiles draw on top.
export function isoDepth(tx: number, ty: number, z = 0): number {
  return (tx + ty) * 1000 + z;
}
